import { render } from "./naem-logo.vue?vue&type=template&id=95a54574"
const script = {}

const cssModules = {}
import style0 from "./naem-logo.vue?vue&type=style&index=0&id=95a54574&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__